module.exports = __webpack_public_path__ + "img/home-menu-gradient.858f9932.png";